import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '@core/config/env.config';

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('Environment Config');
